<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <div class="mb-20 d-flex ">
                <!-- <el-button type="primary" @click="handleAddService" class="ml-auto">
                    <span class="color-white">
                        add service
                    </span>
                </el-button> -->
            </div>
            <el-card class="box-card">
                <el-table :data="services" style="width: 100%">
                    
                    
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <!-- <el-table-column label="Homepage title En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Homepage description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="Homepage title Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Homepage description Ar" class-name="text-right rtl">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                        </template>
                    </el-table-column> -->

                    <el-table-column label="title En" >
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.extendedTranslates,'en_us').title"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="description En" >
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.extendedTranslates,'en_us').description"></span>
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" class-name="text-right rtl">
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.extendedTranslates,'ar_sa').title"></span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="description Ar" class-name="text-right rtl">
                        <template #default="scope">
                           <span v-html="$getLocaleData(scope.row.extendedTranslates,'ar_sa').description"></span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit product"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditService(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedServices(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.services?.list || []
        },
    },
    data(){
        return{
            services:[],
            serviceStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedServices?.length){
            this.getAllServices();
        }else{
            this.services = this.cachedServices;
          
        }
        
       
    },
    
    methods:{
       
        async getAllServices(){
            const response = await this.$store.dispatch('getAllServices');

            this.services = response;
             
        },
        async changeServiceStatus(service){
            const response = await this.$store.dispatch('changeServiceStatus',service.id);
            if (response.data.status == 1){
         
                this.getAllServices();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }else{
                let currentServiceIndex = this.services.findIndex(prt => prt.id == service.id);
                this.services[currentServiceIndex].active = !this.services[currentServiceIndex].active 
                // this.services.splice(currentServiceIndex,1);
            }
             
        },
        async handleAddService(){
            this.$router.push({
                name:'manage-service',
            })
           
        },
        async handleEditService(service){
            await this.$store.dispatch('storeCurrentServiceToView',service)
            this.$router.push({
                name:'manage-service',
                params:{
                    id:service.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>